<template>
  <div id="App">
    <van-nav-bar
      :title="tempTeam.Name"
      :left-text="showReturn ? '返回' : ''"
      :left-arrow="showReturn"
      @click-left="onClickLeft"
    />
    <van-tabs swipeable @change="onLoad" animated v-model="dayActive">
      <van-tab
        v-for="index in 31"
        :key="index"
        :name="index"
        :title="getTitle(index)"
      >
        <van-tabs
          type="card"
          v-model="RySatus"
          @change="onLoad"
          style="margin-top: 5px; margin-bottom: -5px"
        >
          <van-tab :title="'总人数 ' + RS.ZRS"></van-tab>
          <van-tab :title="'在现场 ' + RS.ZXC"></van-tab>
          <van-tab :title="'已离场 ' + RS.YLC"></van-tab>
          <van-tab :title="'未入场 ' + RS.WRC"></van-tab>
        </van-tabs>
        <van-list
          style="margin-top: -15px"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad()"
          ><van-divider />
          <van-cell
            v-for="item in list"
            :key="item.CODE"
            :title="item.NAME"
            :label="item.LOG"
            is-link
            size="large"
            @click="onClickCell(item)"
          >
            <van-tag :type="item.TYPE" class="custom-title" size="large">{{
              item.STATUS
            }}</van-tag>
          </van-cell>
        </van-list>
      </van-tab>
    </van-tabs>
    <Tabbar></Tabbar>
  </div>
</template>

<style>
.custom-title {
  margin-right: 4px;
  vertical-align: right;
}
</style>

<script>
import { mapState } from "vuex";
import Tabbar from "@/components/Tabbar.vue";
import { Dialog } from "vant";
export default {
  data() {
    return {
      list: [],
      dayActive: 1,
      RS: {
        ZRS: 0,
        ZXC: 0,
        YLC: 0,
        WRC: 0,
      },
      showReturn: true,
      RySatus: 0,
      loading: false,
      finished: false,
      team: {
        Code: '',
        Name: '',
      },
      loadingTimes: 0,
    };
  },
  components: {
    Tabbar,
  },
  computed: {
    ...mapState(["userInfo", "tempTeam", "tempPro", "tempDayActive"]),
  },
  methods: {
    getTitle(index) {
      var newDate = new Date(Date.now() - (index - 1) * 24 * 60 * 60 * 1000);
      return newDate.getMonth() + 1 + "/" + newDate.getDate();
    },
    onClickLeft() {
      console.log("返回");
      this.$router.go(-1);
    },
    onClickCell (key) {
      var that = this;
      that.$router.push({ 
          path:'/showWokerInfo',
          name:'ShowWokerInfo', 
          query: {
              ID: key.ID,
              Worker: key.NAME,
              Code: that.tempPro.Code,
              Name: that.tempPro.Name,
              Day: that.tempDayActive,
          }
      })
    },
    onLoad() {
      this.loading = true;
      var that = this;
      if (that.loadingTimes == 0) {
        that.loadingTimes = 1;
        if (typeof that.$route.query.Code === "undefined") {
          that.team = that.tempTeam;
          if(that.dayActive != that.tempDayActive)
          {
            that.dayActive = that.tempDayActive;
            return;
          }
        }
        else{
          that.dayActive = that.tempDayActive;
          that.team = that.$route.query;
        }
      }
      that.$store.commit("setTempTeam", that.team);
      that.$store.commit("setTempDayActive", that.dayActive);
      var newDate = new Date(Date.now() - (that.tempDayActive - 1) * 24 * 60 * 60 * 1000);
      that.$axios({
        method: "post",
        url: "/api/Main",
        data: {
          Method: "GetWechatWorkerList",
          Params: [
            that.userInfo.userCardID,
            that.tempTeam.Code,
            that.userInfo.loginType,
            newDate.getFullYear() +
              "-" +
              (newDate.getMonth() + 1) +
              "-" +
              newDate.getDate(),
            that.RySatus,
          ],
        },
        headers: {
          Authorization: "Bearer " + that.userInfo.token,
        },
      })
        .then((response) => {
          if (response.data.status == "200") {
            that.RS = response.data.Table[0];
            that.list = response.data.Table1;
            that.finished = true;
          } else {
            Dialog({ message: response.data.msg });
            that.finished = true;
          }
        })
        .catch((error) => {
          console.log(error);
          //弹出失败提醒
          Dialog({ message: error.message });
          that.finished = true;
        });
    },
  },
};
</script>
